import { StyleSheet } from "react-native";

import { ADMIN_TOKENS } from "../../../../../styles/adminTokens";

export const messageSharedStyles = StyleSheet.create({
  listItemPressable: {
    borderRadius: ADMIN_TOKENS.radius.md,
  },
  listItemContainer: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.md,
    gap: ADMIN_TOKENS.spacing.sm,
  },
  listItemContainerSelected: {
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  listItemHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  listItemHeaderActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  listItemTitle: {
    flex: 1,
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.semibold,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  listItemTimestamp: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.regular,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  listItemIconActionButton: {
    minHeight: 28,
    minWidth: 28,
    borderRadius: ADMIN_TOKENS.radius.sm,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: ADMIN_TOKENS.spacing.xs,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  listItemIconActionDisabled: {
    opacity: ADMIN_TOKENS.opacity.disabled,
  },
  listItemStatusRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  listItemStatusBadge: {
    borderRadius: ADMIN_TOKENS.radius.xxl,
    paddingHorizontal: ADMIN_TOKENS.spacing.sm,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  listItemStatusBadgeActive: {
    backgroundColor: ADMIN_TOKENS.color.errorBorder,
  },
  listItemStatusBadgeLead: {
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  listItemStatusBadgePatient: {
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
  },
  listItemStatusBadgeText: {
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  listItemPreviewRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  listItemPreviewText: {
    flex: 1,
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.regular,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  listItemUnreadDot: {
    width: ADMIN_TOKENS.spacing.sm,
    height: ADMIN_TOKENS.spacing.sm,
    borderRadius: ADMIN_TOKENS.radius.xxl,
    backgroundColor: ADMIN_TOKENS.color.accent,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderAccent,
  },
  bubbleRow: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  bubbleRowOutbound: {
    justifyContent: "flex-start",
  },
  bubbleContentColumn: {
    flex: 1,
    minWidth: 0,
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  bubbleContentColumnOutbound: {
    justifyContent: "flex-end",
  },
  bubbleContainer: {
    maxWidth: "100%",
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    paddingHorizontal: ADMIN_TOKENS.spacing.sm,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  bubbleContainerInbound: {
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
  },
  bubbleContainerOutbound: {
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  bubbleMessageText: {
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.regular,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  bubbleFooterRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  bubbleMetaColumn: {
    minWidth: ADMIN_TOKENS.spacing.giant,
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  bubbleTimestamp: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.regular,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
});
